import { render } from "./numeric-virtual-keyborad.vue?vue&type=template&id=581adc36&ts=true"
import script from "./numeric-virtual-keyborad.vue?vue&type=script&lang=ts"
export * from "./numeric-virtual-keyborad.vue?vue&type=script&lang=ts"

import "./numeric-virtual-keyborad.vue?vue&type=style&index=0&id=581adc36&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__